
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { PDFDialogComponent } from "src/app/signup-organization/pdf-dialog/pdf-dialog.component";
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from 'src/app/core/services/v2/user.service';
import { EmployerService } from 'src/app/core/services/v2/employer.service';
import { SharedDataService } from 'src/app/core/services/v2/shared-emp-subscription.service';
import { PatientService } from 'src/app/core/services/v2/patient.service';
import { UtilsService } from 'src/app/core/services/v2/utils.service';

@Component({

  selector: 'app-patient-choose-plan',

  templateUrl: './patient-choose-plan.component.html',

  styleUrls: ['./patient-choose-plan.component.scss']

})

export class PatientChoosePlanComponent implements OnInit,AfterViewInit {

  subscriptionTypes:any = [];
 @Input() plans:any=[];
  user: any = [];
  subscriptionType: number;
  selectedType: number = 0;
  activationType: string;
  userId: number;
  // employerId: number;
  isActive: boolean;
  patientId:number;
  subscriptionTypesData: any=[];
  selectedPlan: any={};

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    // private employerService: EmployerService,
    private patientService:PatientService,
    private loaderService: WindowLoaderService,
    public dialog: MatDialog,
    private utils: UtilsService,

    private sharedDataService: SharedDataService // Add this

  ) {}
  ngAfterViewInit(): void {
    // this.getPatientSubscriptionTypes();
    this.getUserDetails();

  }

  ngOnInit() {
  }

  setTypeValue(value: number) {
    // Find the selected plan using the subscription type ID
    const selectedPlan = this.subscriptionTypes.find(plan => plan.id === value);
    
    if (selectedPlan) {
      this.selectedType = selectedPlan.id;

      // Set activationType based on the plan's active status
      this.activationType = selectedPlan.active ? "Activate" : "Deactivate";
    } else {
      console.error('Selected plan not found.');
    }
  }
  getUserDetails() {
    this.loaderService.show();
    this.userService.getUserDetails().subscribe(
      (userDetails) => {
        this.user = userDetails;
        console.log("user", this.user);
        this.userId = userDetails.id;
        this.patientId = userDetails.patientId
        console.log("This is userId: ", this.userId);
        console.log("This is patientId: ", this.patientId);
        // this.getPatientHealthSubscriptionByEmployerId()
        this.getPatientSubscriptionTypes(()=>{this.getPatientHealthSubscriptionByEmployerId();})


      },
      (error) => {
         console.error(error);
              // Hide loader in case of error
      this.loaderService.hide();
       }
    );
  }

  getPatientHealthSubscriptionByEmployerId() {
    this.loaderService.show();
    this.patientService.getPatientSubscriptionDetailsByPatientId(this.user.patientId).subscribe(
      (result) => {
        if (result && result.resultStatus && result.resultStatus.isSuccess) {  // Check if API call was successful
          // this.utils.showMessageSnackBar(result.resultStatus.message || "Success", false); // Show success message

          if (result.result) {
            console.log("Subscription Details:", result);

            // Extract the required data safely
            const active = result.result.active;
            this.selectedType = result.result.subscriptionTypeId;
            this.activationType = active ? "Activate" : "Deactivate";

            // Find the selected plan
            const selectedPlan = this.subscriptionTypes.find(plan => plan.id === result.result.subscriptionTypeId);
            console.log("selectedPlan", selectedPlan);

            if (selectedPlan) {
              // Filter out the selected plan
              this.subscriptionTypes = this.subscriptionTypes.filter(plan => plan.id !== result.result.subscriptionTypeId);
              console.log("Updated subscriptionTypes", this.subscriptionTypes);

              this.selectedPlan = selectedPlan;
              console.log("Updated selectedPlan", this.selectedPlan);
            } else {
              console.warn("No matching subscription type found!");
            }
          } else {
            console.warn("Invalid response structure:", result);
          }
        } else {
          console.warn("API response indicates failure:", result.resultStatus);
          // this.utils.showMessageSnackBar(result.resultStatus.message || "Failed to fetch subscription details", true);
                   // If isSuccess is false, show the error message
                   const errorMessage = result.resultStatus.errorMessages
                   ? result.resultStatus.errorMessages.join(", ")
                   : "Failed to fetch subscription details.";
                 
                //  this.utils.showMessageSnackBar(errorMessage, true);
        }

        this.loaderService.hide();
      },
      (error) => {
        console.error("Error fetching subscription details:", error);
        this.loaderService.hide();
        this.utils.showMessageSnackBar("An error occurred while fetching subscription details", true);
      }
    );
  }

        

  updatePatientHealthSubscription() {

  
    this.loaderService.show();
    this.user.employerId = 0;  // Assign 0 to employerId
    // const isActive = this.activationType === 'Activate';  // True for "Activate", false for "Deactivate"
    this.activationType = "Activate";

    // Check if selectedType is valid and is 'Active'
    if (this.selectedType && this.activationType) {
      // Call the service to update the subscription
    // Navigate to the next component with the subscriptionType as a route parameter
    this.sharedDataService.setData('employerId', this.user.employerId);
    this.sharedDataService.setData('patientId', this.user.patientId);
    this.sharedDataService.setData('subscqriptionTypeId', this.selectedType);
    this.router.navigate(['/patient/setupCheckout', this.selectedType]).then(() => {
      this.loaderService.hide(); // Hide loader after navigation
      document.getElementById("clsModal").click();

    });
  

    } else {
      // Handle invalid selectedType or inactive type
      console.log("Please select a valid active subscription type.");
      this.loaderService.hide(); // Hide loader in case of invalid selection
    }
  }

cancelSubscription() {
    this.loaderService.show();
    this.user.employerId = 0;  // Assign 0 to employerId

    this.activationType = "Deactivate";
    // this.isActive = false;  // Set active to false explicitly for cancelation

    // Call the service to update the subscription
    this.patientService
      .updatePatientHealthSubscription(
        this.user.patientId,
        this.user.employerId,
        this.selectedType,
        this.activationType
      )
      .subscribe(
        (result) => {
          console.log("result update", result);
          this.subscriptionType = this.selectedType;
          this.activationType = this.activationType;
          // this.isActive = result.active;  // Set the active status (false)

          console.log("subscriptionType", this.subscriptionType);
          console.log("activationType", this.activationType);
          console.log("isActive", this.isActive);

            // Call to fetch updated subscription details
            this.getUserDetails();
          this.loaderService.hide();
          document.getElementById("clsModalCancel").click();

        },
        (error) => {
          console.error(error);
          this.loaderService.hide();
        }
      );
  }

  
  openPdfDialog(planId: number) {
    // Find the selected plan by ID
    const selectedPlan = this.subscriptionTypes.find(plan => plan.id === planId);

    // If the plan is found, open the PDF
    if (selectedPlan) {
      window.open(selectedPlan.planDetailsURLIndividual, "_blank");
    } else {
      console.error("Plan not found");
    }
  }
  
  getPatientSubscriptionTypes(cb: () => void) {
    this.loaderService.show();
    this.patientService.getPatientSubscriptionTypes().subscribe(
      (res) => {
        if (res && res.resultStatus && res.resultStatus.isSuccess && res.result && Array.isArray(res.result)) {
          this.subscriptionTypes = res.result; // Assign the correct array
          console.log("Subscription Types:", this.subscriptionTypes);
  
          // Show success message
          // this.utils.showMessageSnackBar(res.resultStatus.message);
  
          if (typeof cb === "function") {
            cb(); // Call callback function if provided
          }
        } else {
          console.warn("Invalid response structure or request was unsuccessful:", res);
          this.subscriptionTypes = []; // Reset to prevent errors
             // Show error message if isSuccess is false
           const errorMessage = res.resultStatus.errorMessages
           ? res.resultStatus.errorMessages.join(", ")
           : "Failed to fetch subscription details.";
         
         this.utils.showMessageSnackBar(errorMessage, true);
        }
  
        this.loaderService.hide();
      },
      (error) => {
        console.error("Error fetching subscription types:", error);
        this.subscriptionTypes = []; // Reset on error
        this.loaderService.hide();
        // Show error message
      this.utils.showMessageSnackBar("An error occurred while fetching subscription types.");
      }
    );
  }
}
